import { AvatarProps, Box, Typography, TypographyProps } from "@mui/material";
import React from "react";
import { User } from "../../../../../authentication/domain";
import { Caption } from "../Caption";
import { BookingItemAvatar } from "./BookingItemAvatar";

export interface BookingItemContentProps {
  avatarImageUrl?: string;
  primary: string;
  primaryTypographyProps?: Partial<TypographyProps>;
  secondary: string;
  AvatarComponent?: React.ElementType<AvatarProps>;
  AvatarProps?: Partial<AvatarProps>;
  user?: User;
}

export const BookingItemContent: React.FC<BookingItemContentProps> = ({
  avatarImageUrl,
  primary,
  primaryTypographyProps,
  secondary,
  AvatarComponent = BookingItemAvatar,
  AvatarProps,
  user,
}) => {
  return (
    <Box
      sx={[{ display: "flex", alignItems: "center", gap: 1 }]}
      className="Item-visibleNoHover"
    >
      <AvatarComponent {...AvatarProps} src={avatarImageUrl} user={user} />
      <Box sx={{ lineHeight: 0, display: "flex", flexDirection: "column" }}>
        <Caption>{secondary}</Caption>
        <Typography variant="body2" {...primaryTypographyProps}>
          {primary}
        </Typography>
      </Box>
    </Box>
  );
};
